// extracted by mini-css-extract-plugin
module.exports = {"title":"DeliveryServices_title__tESVF","services":"DeliveryServices_services__sZmyP"};